import React from 'react';

const TicketsContext = React.createContext({ tickets: [], hasTickets: false });

export default TicketsContext;
